import React from 'react';
import classnames from 'classnames';

import Button from './Button';
import Europe from './Europe.js';
import SSILogo from '../images/ssi-logo.svg';

import { participatingCountries } from '../utils/data';

import grid from '../styles/grid.module.css';
import css from './Hero.module.css';

export const Hero = (props) => {
	return (
		<div className={css.root}>
			<div className={classnames(css.content, grid.root)}>
				<div className={classnames(css.text, grid.column8)}>
					<p>
						EuroMOMO is a European mortality monitoring activity, aiming to detect and measure excess deaths
						related to seasonal influenza, pandemics and other public health threats.
					</p>

					<p>
						Official national mortality statistics are provided weekly from the{' '}
						{participatingCountries.length} European countries or subnational regions in the EuroMOMO
						collaborative network, supported by the European Centre for Disease Prevention and Control
						(ECDC) and the World Health Organization (WHO), and hosted by{' '}
						<a href="https://en.ssi.dk/">Statens Serum Institut</a>, Denmark.
					</p>
				</div>
				<Europe
					className={css.europe}
					countryClassName={css.country}
					participatingClassName={css.highlightedCountry}
				/>
				<div className={classnames(css.left, grid.column4)}>
					<Button invert to="/about-us/history/" className={css.readMoreButton}>
						Read more
					</Button>
				</div>

				<div className={classnames(css.right, grid.column4)}>
					<Button invert to="/graphs-and-maps/" className={css.graphsButton}>
						Graphs and maps
					</Button>
				</div>
			</div>
		</div>
	);
};

export default Hero;
